import React, { useContext, useEffect, useState, useCallback } from 'react'
import { Row, Button } from 'antd'
import { PlaySquareOutlined } from '@ant-design/icons'
import { DiscussionEmbed } from 'disqus-react'

import { connect } from 'react-redux'

import PropTypes from 'prop-types'

import config from '../../../../config';
//
// redux + selectors
import { actions as classActions } from '../../../../redux/modules/class'
import * as authSelectors from '../../../../redux/selectors/auth'
import { actions as courseActions } from '../../../../redux/modules/course'

//
// context
import { CourseContext } from '../../ClassContent/CourseDetail.container'
import VideoPlayer from '../../../../components/VideoPlayer.component'

const propTypes = {
  user: PropTypes.object,
  registerVideoPlay: PropTypes.func.isRequired,
  setClassProperties: PropTypes.func.isRequired,
  videoEmbed: PropTypes.string,
}

function ClassVideo(props) {
  const { course, selectedClass, setSelectedClass } = useContext(CourseContext)
  const [currentVideo, setCurrentVideo] = useState()
  const videos = selectedClass?.aula_videos || []

  useEffect(() => {
    const firstVideo = videos.find(video => video.video_embed)
    setCurrentVideo(firstVideo)
  }, [videos])

  const handlePlayVideo = useCallback((currentVideo) => {
    if (!currentVideo) return

    const { registerVideoPlay, user, setClassProperties } = props
    registerVideoPlay(user.id, course.tag, selectedClass.id, currentVideo.id_video, (payload) => {
      const video_played = payload?.video_played ?? 0
      if (selectedClass.video_played !== video_played) {
        setClassProperties(selectedClass, { video_played }, (newSelectedClass) => {
          setSelectedClass({...newSelectedClass, video_played })
        })
      }
    })
  }, [course.tag, props, selectedClass, setSelectedClass])

  return (
    <>
      <h3>Assista ao vídeo da aula:</h3>
      <div className="video-class">
        <Row className="video-classRow">
          {selectedClass.aula_videos?.length > 1 ? (
            <>
              {selectedClass.aula_videos.map((value, i) => 
                value.video_embed ? (
                  <Button
                    key={value.id_video}
                    icon={<PlaySquareOutlined />}
                    type="primary"
                    className={`pdf-button${currentVideo?.id_video === value.id_video ? ' current' : ''}`}
                    onClick={() => setCurrentVideo(value)}
                    xs={{ span: 8, offset: 4 }}
                    style={{ marginBottom: '4%', cursor: 'pointer' }}
                  >
                    Vídeo {i + 1}
                  </Button>
                ) : null
              )}
              <div style={{ width: '100%' }}>
                {currentVideo?.video_embed && (
                  <VideoPlayer 
                    key={currentVideo.id_video}
                    videoEmbed={currentVideo.video_embed}
                    onPlay={() => handlePlayVideo(currentVideo)}
                  />
                )}
              </div>
            </>
          ) : (
            selectedClass.aula_videos?.map(value => 
              value.video_embed ? (
                <div style={{ width: '100%' }} key={value.id_video}>
                  <VideoPlayer 
                    key={value.id_video}
                    videoEmbed={value.video_embed}
                    onPlay={() => handlePlayVideo(value)}
                  />
                </div>
              ) : null
            )
          )}
        </Row>
      </div>
      {/\(LIVE\)$/i.test(selectedClass.cod_aula) && <DiscussionEmbed
          shortname={config.DISQUS_SHORTNAME}
          config={
              {
                  url: `${window.location.href}?aula=${selectedClass.id}`,
                  identifier: `${course.id_turma}/${selectedClass.id}`,
                  title: `${course.title} ${selectedClass.titulo} ${course.id_turma}`,
                  language: 'pt_BR'
              }
          }
        />}
    </>
  )
}

const mapStateToProps = (state, props) => ({
  user: authSelectors.getUser(state, props),
})

const mapDispatchToProps = (dispatch) => ({
  registerVideoPlay: (userId, courseTag, classId, videoId, next) =>
    dispatch(classActions.registerVideoPlay(userId, courseTag, classId, videoId, next)),
  setClassProperties: (courseId, step, next) =>
    dispatch(courseActions.setClassProperties(courseId, step, next)),
})

ClassVideo.propTypes = propTypes
export default connect(mapStateToProps, mapDispatchToProps)(ClassVideo)
